export const WEBSITE_BUILDER_TYPES = {
  STOREFONT: "storefront",
  QR: "qr",
}

export const normalizeWebsiteBuilderType = value =>
  value === WEBSITE_BUILDER_TYPES.QR ? WEBSITE_BUILDER_TYPES.QR : WEBSITE_BUILDER_TYPES.STOREFRONT

export const getWebsiteBuilderTypeLabelKey = type =>
  type === WEBSITE_BUILDER_TYPES.QR ? "QR Website Builder" : "Website Builder"

export const getWebsiteBuilderTypeDescriptionKey = type =>
  type === WEBSITE_BUILDER_TYPES.QR
    ? "Customize the QR ordering website without affecting ordering APIs."
    : "Customize your customer-facing website without affecting ordering APIs."
